import { motion, AnimatePresence } from 'framer-motion'
import { HiX } from 'react-icons/hi'

export default function PrivacyModal({ isOpen, onClose }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          />

          {/* Modal Content */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="relative w-full max-w-2xl bg-white rounded-3xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col"
            dir="rtl"
          >
            <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-cream/30">
              <h2 className="font-rubik text-xl font-bold text-primary">מדיניות פרטיות ונגישות</h2>
              <button
                onClick={onClose}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors text-text-light"
              >
                <HiX size={24} />
              </button>
            </div>

            <div className="p-8 overflow-y-auto text-right space-y-8">
              <section>
                <h3 className="font-bold text-text mb-3">1. איסוף המידע ומטרתו</h3>
                <p className="text-text-light leading-relaxed text-sm">
                  האתר אוסף מידע אישי (שם, דואר אלקטרוני ומספר טלפון) אך ורק עבור משתמשות המשאירות את פרטיהן באופן יזום בטופס יצירת הקשר או ההרשמה. 
                  המידע משמש אך ורק לצורך מתן מענה לפנייה, תיאום ההרשמה לסדנה ומתן מידע רלוונטי לבקשת המשתמשת.
                </p>
              </section>

              <section>
                <h3 className="font-bold text-text mb-3">2. שמירת המידע ואבטחתו</h3>
                <p className="text-text-light leading-relaxed text-sm">
                  המידע נשמר בבסיס נתונים מאובטח בבעלות בעלות האתר. אנו נוקטים באמצעי זהירות מקובלים כדי להגן על המידע האישי שלך.
                  המידע אינו נמכר, מושכר או מועבר לצדדים שלישיים לצרכי פרסום או שיווק.
                </p>
              </section>

              <section>
                <h3 className="font-bold text-text mb-3">3. שירותי אחסון (Cloud Hosting)</h3>
                <p className="text-text-light leading-relaxed text-sm">
                  האתר מאוחסן בשרתי ענן המופעלים על ידי ספקי שירות מובילים העומדים בתקני אבטחה מחמירים. לצורך שיפור ביצועי האתר וחווית המשתמשת, עשויים להיאסף נתונים טכניים אנונימיים (כגון זמני טעינת דפים וסוג דפדפן). נתונים אלו אינם מאפשרים זיהוי אישי של המשתמשת.
                </p>
              </section>

              <section>
                <h3 className="font-bold text-text mb-3">4. זכויותייך</h3>
                <p className="text-text-light leading-relaxed text-sm">
                  על פי חוק הגנת הפרטיות, התשמ"א-1981, כל אדם זכאי לעיין במידע שעליו המוחזק במאגר מידע. אם מצאת שהמידע עליך אינו נכון, שלם, ברור או מעודכן, הינך רשאית לפנות אלינו בבקשה לתקן את המידע או למחוק אותו מהמאגר.
                </p>
              </section>

              <section className="bg-primary/5 p-6 rounded-2xl border border-primary/10">
                <h3 className="font-bold text-primary mb-3">הצהרת נגישות</h3>
                <p className="text-text-light leading-relaxed text-sm">
                  אנו פועלים להנגשת האתר לכלל הציבור, לרבות אנשים עם מוגבלות, מתוך אמונה כי לכל אדם מגיעה הזכות לחיות בשוויון, כבוד, נוחות ועצמאות.
                  האתר מותאם לתצוגה בדפדפנים נפוצים ולשימוש בטלפון הסלולרי. במידה ונתקלת בבעיית נגישות, נשמח אם תפני אלינו בטופס יצירת הקשר כדי שנוכל לתקנה.
                </p>
              </section>
            </div>

            <div className="p-6 border-t border-gray-100 bg-gray-50 flex justify-end">
              <button
                onClick={onClose}
                className="bg-primary text-white px-8 py-2.5 rounded-full font-medium active:scale-95 transition-all text-sm"
              >
                סגירה
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}
